var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 2.60218 0.158035 2.22064 0.43934 1.93934C0.720644 1.65804 1.10218 1.5 1.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V9C12 9.39782 11.842 9.77936 11.5607 10.0607C11.2794 10.342 10.8978 10.5 10.5 10.5H1.5C1.10218 10.5 0.720644 10.342 0.43934 10.0607C0.158035 9.77936 0 9.39782 0 9V3ZM1.5 2.25C1.30109 2.25 1.11032 2.32902 0.96967 2.46967C0.829018 2.61032 0.75 2.80109 0.75 3V3.16275L6 6.31275L11.25 3.16275V3C11.25 2.80109 11.171 2.61032 11.0303 2.46967C10.8897 2.32902 10.6989 2.25 10.5 2.25H1.5ZM11.25 4.03725L7.719 6.156L11.25 8.32875V4.03725ZM11.2245 9.19425L6.9945 6.591L6 7.18725L5.0055 6.591L0.7755 9.1935C0.818119 9.3531 0.912237 9.49416 1.04324 9.59479C1.17425 9.69541 1.33481 9.74998 1.5 9.75H10.5C10.6651 9.75002 10.8256 9.69557 10.9566 9.59509C11.0876 9.4946 11.1817 9.35371 11.2245 9.19425ZM0.75 8.32875L4.281 6.156L0.75 4.03725V8.32875Z",
    fill: "#545765"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditMail);
export default __webpack_public_path__ + "static/media/credit-mail.5484eb1a0a84086fcf6e8a83430d23c3.svg";
export { ForwardRef as ReactComponent };